/**
 * Котокейсы: витрина и переход к конкретному кейсу.
 *
 * Экран держит только выбор: список приходит с сервера вместе с коллекциями,
 * а всё, что связано с деньгами и прокруткой, живёт в CaseOpenView. Кнопка
 * «назад» внутри кейса возвращает в каталог, а не выбрасывает из раздела.
 */

import { useEffect, useState } from "react";

import type { CaseCollectionDto, CaseDto } from "@koshkodrop/shared";

import { GameShell } from "../components/GameShell";
import { CaseCatalog } from "../games/cases/CaseCatalog";
import { CaseOpenView } from "../games/cases/CaseOpenView";
import { api } from "../lib/api";
import { useSession } from "../store/session";

interface Props {
  onBack: () => void;
}

export function CasesPage({ onBack }: Props) {
  const { balance } = useSession();
  const [collections, setCollections] = useState<CaseCollectionDto[]>([]);
  const [cases, setCases] = useState<CaseDto[]>([]);
  const [openedSlug, setOpenedSlug] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    void api
      .listCases()
      .then((data) => {
        setCollections(data.collections);
        setCases(data.cases);
      })
      .catch(() => setFailed(true));
  }, []);

  const opened = cases.find((item) => item.slug === openedSlug) ?? null;

  if (opened) {
    // «Назад» из кейса ведёт в каталог, а не из раздела: внутри кейса каталог
    // и есть предыдущий экран
    return (
      <GameShell
        title={opened.title}
        subtitle={opened.subtitle ?? undefined}
        onBack={() => setOpenedSlug(null)}
      >
        <CaseOpenView item={opened} />
      </GameShell>
    );
  }

  return (
    <GameShell
      title="Котокейсы"
      subtitle="Шансы видны до открытия, результат считает сервер по вашему сиду"
      onBack={onBack}
    >
      {failed && (
        <p className="rounded-2xl bg-lose-500/15 px-4 py-2.5 text-center text-sm font-semibold text-lose-400">
          Не удалось загрузить каталог
        </p>
      )}

      <CaseCatalog
        collections={collections}
        cases={cases}
        balance={balance}
        onPick={(item) => setOpenedSlug(item.slug)}
      />
    </GameShell>
  );
}
